// src/components/admin/SocialLinksManager.js
import { useState, useEffect } from 'react';
import { FiSave, FiFacebook, FiTwitter, FiLinkedin, FiGithub, FiInstagram } from 'react-icons/fi';
import { useApiAuth } from '../../hooks/useApiAuth';
import { useSiteConfig } from '../../hooks/useSiteConfig';

const PLATFORMS = [
  { key: 'facebook', label: 'Facebook', icon: FiFacebook },
  { key: 'twitter', label: 'Twitter / X', icon: FiTwitter },
  { key: 'linkedin', label: 'LinkedIn', icon: FiLinkedin },
  { key: 'github', label: 'GitHub', icon: FiGithub },
  { key: 'instagram', label: 'Instagram', icon: FiInstagram },
];

function SocialLinksManager() {
  const { config, refresh } = useSiteConfig();
  const { authFetch } = useApiAuth();
  const [links, setLinks] = useState({ facebook: '', twitter: '', linkedin: '', github: '', instagram: '' });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (config.socialLinks) setLinks(prev => ({ ...prev, ...config.socialLinks }));
  }, [config]);

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    try {
      await authFetch('/api/admin/config', {
        method: 'PUT',
        body: { socialLinks: links },
      });
      await refresh();
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      alert('Failed to save: ' + err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="admin-section">
      <h2 className="admin-section-title">Social Media Links</h2>
      <form className="admin-form" onSubmit={handleSave}>
        {PLATFORMS.map(({ key, label, icon: Icon }) => (
          <div className="admin-field" key={key}>
            <label className="admin-label">
              <Icon size={14} /> {label}
            </label>
            <input
              className="admin-input"
              type="url"
              placeholder={`https://${key}.com/yourprofile`}
              value={links[key] || ''}
              onChange={e => setLinks(prev => ({ ...prev, [key]: e.target.value }))}
            />
          </div>
        ))}
        <button className="admin-save-btn" type="submit" disabled={saving}>
          <FiSave size={14} />
          {saving ? 'Saving…' : saved ? 'Saved!' : 'Save Links'}
        </button>
      </form>
    </section>
  );
}

export default SocialLinksManager;
